import React from "react";
import Translate from "../../../common/functions/translate";
import Button from "@material-ui/core/Button";
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField } from '@material-ui/core';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import Paper from '@material-ui/core/Paper';
import { Units } from '../../../common/enums';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const tableSection = (props) => {
    return (
        <>
            {props.products.map((row, index) => (
                <TableRow key={index}>
                    <TableCell component="th" scope="row">
                        {row.articleNumber}
                    </TableCell>
                    <TableCell>{row.article}</TableCell>
                    <TableCell align="right">{HelperFunctions.getEnumLabel(row.unitId, Units, true)}</TableCell>
                    <TableCell align="right">
                        <TextField
                            style={{ width: 50 }}
                            name={"quantity" + index}
                            type="number"
                            disabled={props.readOnly || row.articleNumber === 'ВОИ'}
                            onChange={(e) => props.onChangeQuantity(row, e.target['value'], props.isGasInstall ? 'gasInstallation' : 'heathInstall', props.isAdditionalProducts)}
                            value={row.quantity || ""}
                        />
                    </TableCell>
                    <TableCell align="right">{
                        row.articleNumber === "ВОИ" ?
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <TextField
                                    style={{ width: 80 }}
                                    name={"price" + index}
                                    type="number"
                                    disabled={props.readOnly}
                                    onChange={(e) => props.onChangePrice(row, e.target['value'])}
                                    value={row.price || ""}
                                />
                                <div style={{ lineHeight: '30px', paddingLeft: 5 }}>{Translate('BGN')}</div>
                            </div> :
                            <span>{row.quantity ? (row.price * row.quantity).toFixed(2) + " " + Translate('BGN') : row.price.toFixed(2) + " " + Translate('BGN')}</span>
                    }</TableCell>
                    <TableCell align="right">
                        <Button className="action-button" variant="contained" color='secondary'
                            onClick={() => props.handleDelete(row.productId, props.isAdditionalProducts)} disabled={props.readOnly} >
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </Button>
                    </TableCell>
                </TableRow>
            ))}
        </>
    )
}

const AutoCompleteWithList = (props: any) => {

    return <>
        <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10, alignItems: 'flex-start' }}>
            <Autocomplete
                style={{ marginRight: 5, width: "80%", overflow: "hidden" }}
                options={props.searchedProductsDropDown}
                getOptionLabel={option => option.label}
                value={props.currentSelection}
                onChange={(e, newValue) => props.handleAutocompleteSelection(e, newValue)}
                onKeyUp={(e) => props.handleAutocompleteKeyUp(e.target['value'], props.isGasInstall, props.isAdditionalProducts)}
                noOptionsText={Translate('No records found')}
                disabled={props.readOnly}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={Translate('Search by article number, name, brand, power, supplier...')}
                        placeholder={Translate('Article number or name')}
                        fullWidth
                    />
                )}
            />

            <Button onClick={(e) => props.handleAddButton(props.isGasInstall, props.isAdditionalProducts)}
                color="primary"
                variant="contained"
                style={{ marginTop: 10 }}
                disabled={props.currentSelection === null || props.readOnly}>
                {Translate("Add")}
            </Button>

        </div>
        {props.products.length > 0 ?
            <TableContainer component={Paper} style={{ maxHeight: "600px" }}>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>{Translate("Article number")}</strong></TableCell>
                            <TableCell><strong>{Translate("Article")}</strong></TableCell>
                            <TableCell style={{ width: 80 }} align="right"><strong>{Translate("UnitShort")}</strong></TableCell>
                            <TableCell style={{ width: 80 }} align="right"><strong>{Translate("Qty")}</strong></TableCell>
                            <TableCell style={{ width: 150 }} align="right"><strong>{Translate("Price")}</strong></TableCell>
                            <TableCell align="right"><strong>{Translate("Actions")}</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableSection(props)}
                    </TableBody>
                </Table>
            </TableContainer>
            : null}
        {/* <div style={{ marginBottom: 20, padding: '0px 10px 0px 10px' }}>
            <ul className="list-items">
                {props.products.map((m: ProductModel) =>
                    <li key={m.productId}>
                        <div className="item-info">
                            <div className="item-name">
                                {m.articleNumber} | {m.article}
                            </div>
                            <div className="item-desc">
                                <div className="item-desc-info">
                                    {m.price} {Translate("BGN")}
                                    {HelperFunctions.getEnumLabel(m.unitId, Units, true)}
                                </div>
                            </div>
                        </div>
                        <div className="item-actions">
                            <Button className="action-button" variant="contained" color='secondary' onClick={() => props.handleDelete(m.productId)} >
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </Button>
                        </div>
                    </li>
                )}
            </ul>
        </div> */}
    </>
}

export default AutoCompleteWithList;
